import { memo } from 'react'
import { ChevronRightIcon } from '~/icons/chevron-right'

interface PaymentMethodOptionProps {
  icon: React.ReactNode
  label: string
  value: string
  checked?: boolean
  onChange: (value: string) => void
  rightContent?: React.ReactNode
  showArrow?: boolean
}

const PaymentMethodOption = ({
  icon,
  label,
  value,
  checked,
  onChange,
  rightContent,
  showArrow = false,
}: PaymentMethodOptionProps) => {
  return (
    <label
      className="flex cursor-pointer items-center justify-between rounded-[6px] border border-[##CED0D3] p-4 hover:bg-gray-100"
      onClick={() => showArrow && onChange(value)}
    >
      <div className="grid grid-cols-1 items-center justify-between text-xs md:grid-cols-2">
        <span className="flex items-center justify-between gap-2 text-[14px]">
          {icon} {label}
        </span>
        {rightContent && (
          <span className="mt-1 flex items-center justify-start gap-1 ps-6 sm:ps-2">
            {rightContent}
          </span>
        )}
      </div>

      {showArrow ? (
        <span className="mt-[2px]">
          <ChevronRightIcon />
        </span>
      ) : (
        <>
          <input
            type="radio"
            name="payment"
            value={value}
            className="peer hidden"
            checked={checked}
            onChange={(e) => onChange(e.target.value)}
          />
          <div className="flex h-4 w-4 items-center justify-center rounded-full border-2 border-gray-400 peer-checked:border-primary-500 peer-checked:bg-primary-500">
            <div className="h-3 w-3 rounded-full border-2 border-white"></div>
          </div>
        </>
      )}
    </label>
  )
}

function arePropsEqual(
  prevProps: PaymentMethodOptionProps,
  nextProps: PaymentMethodOptionProps
): boolean {
  // Compare primitive props first
  if (
    prevProps.value !== nextProps.value ||
    prevProps.checked !== nextProps.checked ||
    prevProps.label !== nextProps.label ||
    prevProps.showArrow !== nextProps.showArrow
  ) {
    return false
  }

  // Compare icon and rightContent references
  // Since these are React nodes, we only compare their references
  return prevProps.icon === nextProps.icon && prevProps.rightContent === nextProps.rightContent
}

export default memo(PaymentMethodOption, arePropsEqual)
